const isLidLike = value =>
  typeof value === "string" && /@lid$/i.test(value.trim());

const cleanLidValue = value =>
  typeof value === "string" ? value.replace(/@lid$/i, "").trim() : "";

const formatUsername = value => {
  if (typeof value !== "string") return "";
  const username = value.trim();
  if (!username) return "";
  return username.startsWith("@") ? username : `@${username}`;
};

const formatContactDisplayName = contact => {
  if (!contact) {
    return "Contato";
  }

  const name = typeof contact.name === "string" ? contact.name.trim() : "";
  const number = typeof contact.number === "string" ? contact.number.trim() : "";
  const lid = typeof contact.lid === "string" ? contact.lid.trim() : "";
  const username = formatUsername(contact.username);
  const lidDigits = cleanLidValue(lid);
  const normalizedName = cleanLidValue(name).replace(/\D/g, "");
  const usefulName = Boolean(
    name &&
    !isLidLike(name) &&
    /[\p{L}\p{N}]/u.test(name) &&
    name !== number &&
    name !== lidDigits &&
    (!normalizedName || (normalizedName !== number && normalizedName !== lidDigits))
  );

  if (usefulName) {
    return name;
  }

  if (username) {
    return username;
  }

  if (number) {
    return number;
  }

  if (lid) {
    return cleanLidValue(lid);
  }

  return cleanLidValue(name) || "Contato";
};

export default formatContactDisplayName;
